const getUrlQuery = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
  var r = decodeURI(window.location.search)
    .substr(1)
    .match(reg); // 匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
};

// 获取url中的参数
export const getUrlParam = getUrlQuery;
function isIos() {
  var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
  if (iOS) {
    return true;
  }
  return false;
}

export const IosInputBug = class IosInputBug {
  constructor() {
    this.scrollT = 0;
    this.isIOS = isIos();
  }
  open() {
    // 打开弹窗时
    if (!this.isIOS) return;
    this.scrollT = window.scrollY;
    document.body.classList.add(".ios-focus");
    window.scrollTo(0, this.scrollT);
  }
  close() {
    // 关闭弹窗时
    if (!this.isIOS) return;
    document.body.classList.add(".ios-blur");
    window.scrollTo(0, this.scrollT);
  }
};

export const calcSubmit = val => {
  // 当天内不可重复提交
  // 20191118,buy
  // 20191118,rent
  let currentTime = new Date();
  let year = currentTime.getFullYear();
  let mounth = currentTime.getMonth() + 1;
  let date = currentTime.getDate();
  if (val) {
    // 存
    localStorage.submitTimeValue = `${year}${mounth}${date},${val}`;
    return localStorage.submitTimeValue;
  } else {
    // 取
    let oldTime = localStorage.submitTimeValue;
    if (oldTime) {
      let oldList = oldTime.split(",");
      if (oldList[0] === `${year}${mounth}${date}`) {
        return oldList[1];
      }
    }
  }
};

export const getshareTitle = (payload, page) => {
  let options = {
    title: "买车首付0元起，租车免半月租金",
    content: "买车限时省5000，还有机会得华为mate30，行车记录仪，通兑电影票呦~"
  };
  if (Math.random() > 0.5) {
    options = {
      title: "买车首付0元起，租车免半月租金",
      content: "买车限时省5000，还有机会得华为mate30，行车记录仪，通兑电影票呦~"
    };
  }
  return options;
};

export const filterCityDistrict = formatted_address => {
  // 浙江省杭州市西湖区北山街道省府路11号浙江省人民政府  30.26555, 120.1536
  // 北京市房山区琉璃河镇国家电网汽车充电站(房山养老公寓东南)
  // 上海市宝山区张庙街道通河八村  31.329743, 121.448301
  let addressCity = "";
  let addressDistrict = "";
  if (typeof formatted_address === "string" && formatted_address) {
    if (formatted_address.includes("市")) {
      let startStr = formatted_address.slice(
        0,
        formatted_address.indexOf("区") + 1
      );
      if (startStr.includes("省") && startStr.includes("市")) {
        addressCity = startStr.slice(
          startStr.indexOf("省") + 1,
          startStr.indexOf("市")
        );
      }
      if (startStr.includes("市") && startStr.includes("区")) {
        if (!addressCity)
          addressCity = startStr.slice(0, startStr.indexOf("市"));
        addressDistrict = startStr.slice(
          startStr.indexOf("市") + 1,
          startStr.indexOf("区") + 1
        );
      }
    }
  }
  let data = {
    addressCity, // 深圳
    addressDistrict // 福田区
  };
  return data;
};

export const getNetworkType = () => {
  const ua = navigator.userAgent;
  const cc = navigator.connection;
  let result = ua.match(/NetType\/\w+/);
  if (result) {
    result = result.toLowerCase().replace("nettype/", "");
  } else if (cc && cc.effectiveType) {
    result = cc.effectiveType;
    if (["none", "other"].includes(result)) {
      result = "unknow";
    }
  } else {
    result = "unknow";
  }
  return result;
};
